import useInlinePageRouter from 'components/__new/general/useInlinePageRouter';
import FormDrawer from 'components/__new/common/form-drawer';
import EarnipaySingleBeneficiary from './EarnipaySingleBeneficiary';
import Maybe from 'components/__new/common/Maybe';
import BankSingleBeneficiary from './BankSingleBeneficiary';
import { useSelector } from 'react-redux';


const SingleBeneficiaryType = ({
    isOpen,
    setIsOpen,
    beneficiaryTypes,
    setBeneficiaryType,
    toggleBeneficiaryType,
    initiateBeneficiaryCreation,
}) => {
    const { InlineRouterTab, activeTab } = useInlinePageRouter("earnipay");
    const { transferBeneficiaryLoading: loading, transferBeneficiary } = useSelector((state) => state.entities.transfers)
    
    return (
        
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={() => {}}>
            <div className="p-6">
                
                <FormDrawer.Title
                    close={setIsOpen}
                    showCloseButton={true}
                    title="Add Single Beneficiary"
                    description="Create and add new beneficiaries to your list"
                />
                
                <div className="w-full mt-5">
                    <InlineRouterTab
                        tabMode
                        useFullWidth
                        items={beneficiaryTypes}
                        onTabChange={(activeItem) => setBeneficiaryType(activeItem)}
                    />
                    
                    <div className="pt-4">
                        <Maybe condition={activeTab === "earnipay"}>
                            <EarnipaySingleBeneficiary
                                loading={loading}
                                transferBeneficiary={transferBeneficiary}
                                toggleBeneficiaryType={toggleBeneficiaryType}
                                initiateBeneficiaryCreation={initiateBeneficiaryCreation}
                                setIsOpen={setIsOpen}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === "bank"}>
                            <BankSingleBeneficiary
                                loading={loading}
                                transferBeneficiary={transferBeneficiary}
                                toggleBeneficiaryType={toggleBeneficiaryType}
                                initiateBeneficiaryCreation={initiateBeneficiaryCreation}
                                setIsOpen={setIsOpen}
                            />
                        </Maybe>
                    </div>
                </div>
            </div>
        </FormDrawer>
        
    )
}

export default SingleBeneficiaryType